// //cdn.cookie-script.com/s/c18d8007d84d6312ca53fbd317e84e69.js

import { Script } from "gatsby";

function CookieScript() {
    return <Script src="//cdn.cookie-script.com/s/c18d8007d84d6312ca53fbd317e84e69.js" />
}

export default CookieScript